import { Component } from '@angular/core';

@Component({
    selector: 'app-layout',
    styles: [':host ::ng-deep .mat-drawer-content {padding: 0;} .mat-drawer-container {z-index: 1000}'],
    templateUrl: './auth-layout.component.html',
    standalone: false
})
export class AuthLayoutComponent {
    // TODOEVENTUALLY MMD - connecting...??
    constructor() {}
}
